import { render, staticRenderFns } from "./Photo_View.vue?vue&type=template&id=61f06ff4&scoped=true"
import script from "./Photo_View.vue?vue&type=script&lang=js"
export * from "./Photo_View.vue?vue&type=script&lang=js"
import style0 from "./Photo_View.vue?vue&type=style&index=0&id=61f06ff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f06ff4",
  null
  
)

export default component.exports